import AllRoutes from "./all.routes"
import store from "../store/index.js"

import Login from "@/views/account/AccountLogin1.vue"
import Register from "@/views/account/AccountRegister.vue"
import ForgotPassword from "@/views/account/AccountForgotPassword.vue"
import ResetPassword from "@/views/account/AccountResetPassword.vue"

const ifNotAuthenticated = (to, from, next) => {

    next();

    // if (!store.getters.isAuthenticated) {
    //     next()
    //     return
    // }

    // next(AllRoutes.Account.Login)
}

export default [

    {
        path: AllRoutes.Account.Login,
        component: Login,
        beforeEnter: ifNotAuthenticated,
        meta: {
            layout: "loginLayout",
            title: "Авторизация"
        }
    },

    {
        path: AllRoutes.Account.Register,
        component: Register,
        beforeEnter: ifNotAuthenticated,
        meta: {
            layout: "loginLayout",
            title: "Регистрация"
        }
    },

    {
        path: AllRoutes.Account.ForgotPassword,
        component: ForgotPassword,
        beforeEnter: ifNotAuthenticated,
        meta: {
            layout: "loginLayout",
            title: "Забыли пароль?"
        }
    },

    {
        path: AllRoutes.Account.ResetPassword,
        component: ResetPassword,
        beforeEnter: ifNotAuthenticated,
        meta: {
            layout: "loginLayout",
            title: "Восстановление пароля"
        }
    }

]